/**
 * TUPU Stock - Sistema de Tokens de Marca
 * 
 * Este archivo centraliza TODA la identidad visual de TUPU Stock.
 * Cambiar un valor aquí actualiza toda la aplicación.
 * 
 * IMPORTANTE: La identidad de TUPU Stock es fija y no configurable por el cliente.
 * TUPU es la marca madre. Stock es el producto.
 */

// ============================================
// INFORMACIÓN DE MARCA
// ============================================
export const BRAND = {
  name: 'TUPU Stock',
  shortName: 'TUPU',
  product: 'Stock',
  tagline: 'Inventario · Pedidos · Abastecimiento',
  version: '1.0.0',
  company: 'TUPU',
};

// ============================================
// LOGOS (rutas fijas del sistema)
// ============================================
export const LOGOS = {
  horizontal: '/images/logo-horizontal.svg',
  square: '/images/logo-square.svg',
  login: '/images/logo-horizontal.svg',
  favicon: '/images/logo-square.svg',
};

// ============================================
// PALETA DE COLORES TUPU STOCK
// ============================================
export const COLORS = {
  // Color principal (Naranja TUPU)
  primary: {
    DEFAULT: '#F97316',
    hover: '#EA580C',
    light: '#FFF1E6',
    50: '#FFF7ED',
    100: '#FFEDD5',
    200: '#FED7AA',
    300: '#FDBA74',
    400: '#FB923C',
    500: '#F97316',
    600: '#EA580C',
    700: '#C2410C',
  },
  
  // Color secundario/acento (Amarillo TUPU)
  accent: {
    DEFAULT: '#FACC15',
    light: '#FFF8D6',
    50: '#FEFCE8',
    100: '#FEF9C3',
    200: '#FEF08A',
    300: '#FDE047',
    400: '#FACC15',
    500: '#EAB308',
    600: '#CA8A04',
  },
  
  // Fondos y superficies
  background: {
    DEFAULT: '#FAFAF7',
    surface: '#FFFFFF',
    secondary: '#F6F3EC',
    sidebar: '#FFFDF8',
  },
  
  // Bordes
  border: {
    DEFAULT: '#E9E4DA',
    light: '#F0EDE6',
  },
  
  // Textos
  text: {
    primary: '#153D35',
    secondary: '#68756F',
    muted: '#929C97',
    inverse: '#FFFFFF',
  },
  
  // Verde corporativo TUPU (usado en logos y elementos de marca)
  brand: {
    green: '#153D35',
  },
  
  // Estados semánticos (no modificar - son estándares)
  semantic: {
    success: '#16A34A',
    warning: '#F59E0B',
    error: '#DC2626',
    info: '#3B82F6',
  },
  
  // Sidebar - Naranja TUPU Stock (alta visibilidad)
  sidebar: {
    bg: '#F97316',
    border: '#EA580C',
    text: '#FFFDF8',
    icon: '#FFFDF8',
    hoverBg: '#EA580C',
    hoverText: '#FFFFFF',
    activeBg: '#FFFFFF',
    activeText: '#F97316',
    activeIcon: '#F97316',
  },
};

// ============================================
// TIPOGRAFÍA
// ============================================
export const TYPOGRAPHY = {
  fontFamily: {
    sans: "'Sofia Sans', sans-serif",
    mono: "'JetBrains Mono', monospace",
  },
  fontWeight: {
    normal: 400,
    medium: 500,
    semibold: 600,
    bold: 700,
  },
};

// ============================================
// ESPACIADO Y BORDES
// ============================================
export const SPACING = {
  borderRadius: {
    sm: '0.375rem',
    DEFAULT: '0.5rem',
    md: '0.75rem',
    lg: '1rem',
    xl: '1.5rem',
    full: '9999px',
  },
};

// ============================================
// VARIABLES CSS (para usar en estilos inline)
// ============================================
export const CSS_VARS = {
  '--tupu-primary': COLORS.primary.DEFAULT,
  '--tupu-primary-hover': COLORS.primary.hover,
  '--tupu-primary-light': COLORS.primary.light,
  '--tupu-accent': COLORS.accent.DEFAULT,
  '--tupu-accent-light': COLORS.accent.light,
  '--tupu-background': COLORS.background.DEFAULT,
  '--tupu-surface': COLORS.background.surface,
  '--tupu-surface-secondary': COLORS.background.secondary,
  '--tupu-border': COLORS.border.DEFAULT,
  '--tupu-text': COLORS.text.primary,
  '--tupu-text-secondary': COLORS.text.secondary,
  '--tupu-text-muted': COLORS.text.muted,
  '--tupu-brand-green': COLORS.brand.green,
  '--tupu-sidebar-bg': COLORS.sidebar.bg,
  '--tupu-sidebar-border': COLORS.sidebar.border,
  '--tupu-sidebar-active-bg': COLORS.sidebar.activeBg,
  '--tupu-sidebar-active-text': COLORS.sidebar.activeText,
};

// ============================================
// EXPORTACIÓN POR DEFECTO
// ============================================
const TupuBrand = {
  BRAND,
  LOGOS,
  COLORS,
  TYPOGRAPHY,
  SPACING,
  CSS_VARS,
};

export default TupuBrand;
